<template>
    <div>
        <van-popup v-model="show" round position="bottom" @click-overlay="close">
            <div class="content">
                <i class="iconfont icon-cuowu_shibai close-icon" @click="close"></i>
                <div class="info">
                    <img class="logo" :src="logoUrl" mode="aspectFit" />
                    <div class="tips">{{ $t('downApp.SaveVersionTips') }}</div>
                </div>
                <div class="btns">
                    <div @click="close">{{ $t('lang.cancel') }}</div>
                    <div @click="onDownApp">{{ $t('downApp.Install') }}</div>
                </div>
            </div>
        </van-popup>
        <tipsPopup ref="Tips1Popup" :tips="$t('downApp.downAppSuccTips')"></tipsPopup>
        <tipsPopup ref="Tips2Popup" :tips="$t('downApp.downAppSuccTips2')" @close="toHome" @confirm="toHome"></tipsPopup>
        <tipsPopup ref="Tips3Popup" :tips="$t('downApp.NotInDevice')" @close="toHome" @confirm="toHome"></tipsPopup>
    </div>
</template>

<script>
import tipsPopup from './tipsPopup'
let savedPwaPrompt888 = null
export default {
    components: { tipsPopup },
    data() {
        return {
            show: false,
            isShowTipsPopup: false,
            isShowTips2Popup: false,
            isShowTips3Popup: false,
            savedPwaPrompt: null
        }
    },
    props: {
        isToHome: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        logoUrl() {
            return this.$store.getters.sysConfig?.homeImageUrl
        }
    },
    mounted() {
        try {
            this.$nextTick(() => {
                window.addEventListener('beforeinstallprompt', function (e) {
                    console.log(savedPwaPrompt888, 'this.savedPwaPrompt666====')
                    // 阻止默认提示弹出
                    e.preventDefault()
                    // 把事件存起来
                    savedPwaPrompt888 = e
                    console.log(savedPwaPrompt888, 'this.savedPwaPrompt8888====')
                })
            })
        } catch {
            console.log('error-pwa-不支持？不显示？')
        }
    },
    methods: {
        open() {
            const that = this
            that.show = true
        },
        close() {
            this.show = false
        },
        onDownApp() {
            const that = this
            if ('serviceWorker' in navigator) {
                try {
                    savedPwaPrompt888.prompt()
                    savedPwaPrompt888.userChoice.then(choiceResult => {
                        if (choiceResult.outcome === 'accepted') {
                            that.close()
                            // this.isShowTipsPopup = true
                            // uni.reLaunch({
                            // 	url: '/pages/index/index'
                            // })
                        } else {
                            console.log('用户拒绝安装PWA--可打印')
                        }
                    })
                } catch (e) {
                    that.close()
                    that.$refs.Tips2Popup.open()
                    console.log(e, 'error-pwa-不支持？不显示？')
                    // pwaIconShow.value = false
                }
            } else {
                that.$refs.Tips3Popup.open()
            }
        },
        toHome() {
            if (!this.isToHome) return
            this.onPageRefresh()
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';
::v-deep .van-popup--bottom {
    overflow: visible;
    background: transparent !important;
    box-shadow: none !important;
}

.content {
    padding: .28rem;
    padding-bottom: 0;
    padding-top: .38rem;
    box-sizing: border-box;
    width: 100%;
    background:
        radial-gradient(circle at top center, rgba(var(--theme-input-focus-border-rgb), 0.22) 0%, rgba(var(--theme-input-focus-border-rgb), 0) 42%),
        $bg-component-blue-deep-gradient-color;
    border: .02rem solid rgba(var(--theme-input-focus-border-rgb), 0.34);
    box-shadow: 0 -.08rem .32rem rgba($bg-shell-color, 0.18);
    border-radius: .2rem .2rem 0 0;

    .close-icon {
        width: 35px;
        height: 35px;
        vertical-align: middle;
        position: absolute;
        right: .2rem;
        top: -45px;
        cursor: pointer;
        font-size: .62rem;
        color: $font-component-surface-white-color;
        text-shadow: 0 0 .12rem rgba(var(--theme-input-focus-border-rgb), 0.28);
    }

    .info {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .logo {
            width: 1.3rem;
            height: 1.3rem;
            vertical-align: middle;
        }

        .tips {
            width: calc(100% - 150upx);
            color: $font-component-surface-soft-color;
            font-size: .28rem;
            line-height: .38rem;
        }
    }

    .btns {
        height: 1.3rem;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        &>div {
            width: 1.8rem;
            height: .8rem;
            border-radius: .1rem;
            background: $bg-component-highlight-color;
            border: .01rem solid rgba(var(--theme-input-focus-border-rgb), 0.32);
            box-shadow: inset 0 .01rem .12rem rgba($font-title-color, 0.24), 0 .06rem .18rem rgba($bg-shell-color, 0.18);
            color: $font-component-surface-white-color;
            margin-left: .2rem;
            text-align: center;
            line-height: .78rem;
            cursor: pointer;

            &:first-child {
                background: $bg-component-deep-color;
                color: $font-component-cool-muted-color;
                border-color: rgba(var(--theme-input-focus-border-rgb), 0.24);
                box-shadow: inset 0 .01rem .1rem rgba($font-title-color, 0.08);
            }
        }
    }
}
</style>
